import { render, staticRenderFns } from "./menuItemWithSubmenu.vue?vue&type=template&id=f00111ce&scoped=true&"
import script from "./menuItemWithSubmenu.vue?vue&type=script&lang=js&"
export * from "./menuItemWithSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./menuItemWithSubmenu.vue?vue&type=style&index=0&id=f00111ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00111ce",
  null
  
)

export default component.exports